var _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSeatPlane(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_8354",
    "data-name": "Group 8354",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 9.662,
    height: 11.746,
    viewBox: "0 0 9.662 11.746",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_176",
    "data-name": "Rectangle 176",
    width: 9.662,
    height: 11.746,
    fill: "#009bdc"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_8353",
    "data-name": "Group 8353",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1430",
    "data-name": "Path 1430",
    d: "M8.379,11.742c-.489,0-.977,0-1.466,0H3.271l-.2-1.222c-.02-.121-.037-.243-.059-.363a.1.1,0,0,0-.122-.094c-.377,0-.754,0-1.149,0-.05-.237-.1-.477-.151-.717q-.153-.761-.3-1.523c-.087-.446-.169-.894-.255-1.34S.861,5.613.774,5.176q-.121-.61-.243-1.22c-.1-.5-.208-1-.294-1.5A9.024,9.024,0,0,1,0,1.043,1.075,1.075,0,0,1,.707.07,1.7,1.7,0,0,1,2.23.354a1.932,1.932,0,0,1,.7,1.232c.1.434.2.868.294,1.3l.4,1.79q.03.132.056.264c.018.091.083.088.155.088H7.554v.832H3.911c.058.264.108.515.172.761A.162.162,0,0,0,4.21,6.7c.293.007.586,0,.88,0,.857,0,1.713,0,2.57,0a2.031,2.031,0,0,1,1.334.415,1.653,1.653,0,0,1,.61.987A3.766,3.766,0,0,1,9.66,8.9a1.086,1.086,0,0,1-.8,1.125.869.869,0,0,1-.265.042c-1.573,0-3.146,0-4.747,0l.123.813.024.022,3.784,0c.2,0,.4,0,.6.005l.022.025v.779l-.022.024",
    transform: "translate(0.001 0)",
    fill: "#009bdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1431",
    "data-name": "Path 1431",
    d: "M106.666,292.2l-.024-.022.024.022",
    transform: "translate(-102.67 -281.298)",
    fill: "#009bdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1432",
    "data-name": "Path 1432",
    d: "M225.028,293.051l-.022-.025.022.025",
    transform: "translate(-216.626 -282.113)",
    fill: "#009bdc"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_1433",
    "data-name": "Path 1433",
    d: "M225,314.656l.022-.024-.022.024",
    transform: "translate(-216.62 -302.915)",
    fill: "#009bdc"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSeatPlane);
export default __webpack_public_path__ + "static/media/seat-plane.1be4bd4d54b619b90e725ba60a9752b4.svg";
export { ForwardRef as ReactComponent };